<template>
	<span class="rb-badge" :class="{circle}">
		<slot></slot>
	</span>
</template>

<script>
	export default {
		name: 'RbBadge',
		props: {
			circle: {
				type: Boolean,
				default: false
			}
		},
		data: () => ({}),
	}
</script>

<style lang="scss" scoped>
	.rb-badge {
		font-size: $font-size-xxs;
		background: rgba($primary-3, .5);
		border-radius: 1em;
		padding: 0 .5em;
		margin: 0 -.5em;

		display: inline-block;

		& + & {
			margin-left: .5em;
		}

		&.circle {
			width: 1.5em;
			padding: 0;
			text-align: center;
		}
	}
</style>
